import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-icon-eye",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./eye.component.html",
})
export class EyeIconComponent {
  @Input() slashed: boolean = false;
}
